import { Button, CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import styled from "styled-components";

export const PopupModal = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <BoxStyle className="modal">{props.children}</BoxStyle>
        </Modal>
    );
};

export const DeleteModal = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <BoxStyle className="modal">
                <h3>
                    Are you sure you want to Delete <span>{props.title}</span>
                </h3>
                <div className="buttons">
                    <Button onClick={props.close} className="cancel">
                        cancel
                    </Button>
                    <Button onClick={props.onClick} className="delete">
                        {props.loading ? (
                            <CircularProgress size={20} color="error" />
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </div>
            </BoxStyle>
        </Modal>
    );
};

const BoxStyle = styled.div`
    width: 60%;
    padding: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--white);
    border-radius: 1rem;
    @media screen and(max-width:992px) {
        width: 90%;
    }
    h3 {
        text-align: center;
        margin: 1rem 0;
        font-size: 1.7rem;
        color: var(--gray);
        span {
            color: var(--light-blue);
            margin: 0 0.5rem;
        }
    }
    .buttons {
        display: flex;
        justify-content: center;
        margin: 2rem 0 0 0;
        .cancel {
            background: var(--gray);
            color: #fff;
            padding: 0.5rem 2rem;
            margin: 0 0.5rem;
            border-radius: 0.9rem;
        }
        .delete {
            background: #ff6f6f;
            color: #fff;
            padding: 0.5rem 2rem;
            border-radius: 0.9rem;
            margin: 0 0.5rem;
        }
    }
`;
